export default "__VITE_PUBLIC_ASSET__1c2de2d4__"